import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { fileHashFieldNames, hostFieldNames } from "@app2/util/constants";
import { Instant, ZonedDateTime, ZoneId } from "@js-joda/core";
import { zonedDateTimeToISOString } from "@app2/util/js-joda-util";

enum FieldType { timestamp, ip, mac, hostname, filehash, plaintext};

@Component({
    selector: "search-results-table-detailed-value",
    template: `
        <ng-container [ngSwitch]="valueType">
            <span *ngSwitchCase="FieldType.plaintext" class="field-value">
                {{ text }}
            </span>

            <span *ngSwitchCase="FieldType.timestamp" class="field-value">
                {{ epochToString(text) | longDate }}
            </span>

            <span *ngSwitchCase="FieldType.ip" class="field-value">
                <ip-dropdown [ip]="text" [eventTime]="eventTime"></ip-dropdown>
                <asset-dropdown [ip]="text" [eventTime]="eventTime"></asset-dropdown>
            </span>

            <ng-container *ngSwitchCase="FieldType.mac">
                {{ text }}
                <asset-dropdown [mac]="text" [eventTime]="eventTime"></asset-dropdown>
            </ng-container>

            <ng-container *ngSwitchCase="FieldType.hostname">
                {{ text }}
                <asset-dropdown [hostname]="text" [eventTime]="eventTime"></asset-dropdown>
            </ng-container>

            <hash-dropdown *ngSwitchCase="FieldType.filehash"
                           [hash]="text"
                           [eventTime]="eventTime">
            </hash-dropdown>
        </ng-container>

        <threat-rating *ngIf="canRateThreat"
                       [threat]="text">
        </threat-rating>
    `,
    styles: [`
        :host {
            margin-right: 20px;
            display: inline-flex;
            max-width: 75%;
            align-items: center;
        }

        .field-value, threat-rating, ip-dropdown, hash-dropdown {
            margin-right: 5px;
        }
    `]
})
export class SearchResultsTableDetailedValueComponent implements OnChanges {
    @Input() text: string;
    @Input() key: string;
    @Input() eventTime: number;

    FieldType = FieldType;
    valueType: FieldType;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.key) {
            this.valueType = this.getFieldType();
        }
    }

    get canRateThreat(): boolean {
        return this.valueType === FieldType.ip ||
            this.valueType === FieldType.mac ||
            this.valueType === FieldType.hostname ||
            this.valueType === FieldType.filehash;
    }

    epochToString(value: any): string {
        return zonedDateTimeToISOString(ZonedDateTime.ofInstant(Instant.ofEpochMilli(<number>value), ZoneId.UTC));
    }

    private getFieldType(): FieldType {
        if (this.key.endsWith("timestamp")) {
            return FieldType.timestamp;
        }
        if (this.key === "ip" ||
            ((this.key.startsWith("ip_") || this.key.endsWith("_ip")) &&
                !(this.key.includes("cidr") || this.key.includes("type")))) {
            return FieldType.ip;
        }
        if (this.key.search(/mac[-_]?address/) > -1) {
            return FieldType.mac;
        }
        if (hostFieldNames.indexOf(this.key) > -1) {
            return FieldType.hostname;
        }
        if (fileHashFieldNames.indexOf(this.key) > -1) {
            return FieldType.filehash;
        }
        return FieldType.plaintext;
    }
}
